import DisclosureStep from './DisclosureStep'
import FallbackStep from './FallbackStep'
import React from 'react'
import ReviewPrescriptionStep from './ReviewPrescriptionStep'
import styled from '@emotion/styled'

interface MillimanStepperProps {
  setShowAddDrugComponent: React.Dispatch<React.SetStateAction<boolean>>
}

const ContentWrapper = styled.div``

const MillimanStepper: React.FC<MillimanStepperProps> = ({
  setShowAddDrugComponent,
}) => {
  const [step, setStep] = React.useState(1)
  return (
    <ContentWrapper>
      {step === 1 && (
        <DisclosureStep
          setStep={setStep}
          setShowAddDrugComponent={setShowAddDrugComponent}
        />
      )}
      {step === 2 && (
        <ReviewPrescriptionStep
          setShowAddDrugComponent={setShowAddDrugComponent}
          setStep={setStep}
        />
      )}
      {step === 3 && (
        <FallbackStep setShowAddDrugComponent={setShowAddDrugComponent} />
      )}
    </ContentWrapper>
  )
}

export default MillimanStepper
